var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2061 41.7675L13.6343 30.1929L17.4906 26.3365L25.2061 34.0493L40.6316 18.6211L44.4906 22.4802L25.2061 41.7675Z",
    fill: "#06077D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30C0 13.4318 13.4318 0 30 0C46.5682 0 60 13.4318 60 30C60 46.5682 46.5682 60 30 60C13.4318 60 0 46.5682 0 30ZM30 54.5455C26.7766 54.5455 23.5849 53.9106 20.6069 52.677C17.6289 51.4435 14.923 49.6355 12.6437 47.3563C10.3645 45.077 8.55648 42.3711 7.32296 39.3931C6.08943 36.4151 5.45454 33.2234 5.45454 30C5.45454 26.7766 6.08943 23.5849 7.32296 20.6069C8.55648 17.6289 10.3645 14.923 12.6437 12.6437C14.923 10.3645 17.6289 8.55648 20.6069 7.32296C23.5849 6.08943 26.7766 5.45455 30 5.45455C36.5099 5.45455 42.7531 8.04058 47.3563 12.6437C51.9594 17.2469 54.5455 23.4901 54.5455 30C54.5455 36.5099 51.9594 42.7531 47.3563 47.3563C42.7531 51.9594 36.5099 54.5455 30 54.5455Z",
    fill: "#06077D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutline);
export default __webpack_public_path__ + "static/media/check_outline.15f13a55.svg";
export { ForwardRef as ReactComponent };